import { render, staticRenderFns } from "./BusinessCentralOrdersWidget.vue?vue&type=template&id=843f587a&scoped=true&"
import script from "./BusinessCentralOrdersWidget.vue?vue&type=script&lang=ts&"
export * from "./BusinessCentralOrdersWidget.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessCentralOrdersWidget.vue?vue&type=style&index=0&id=843f587a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843f587a",
  null
  
)

export default component.exports